export default "__VITE_ASSET__8b306fab__"